import { render, staticRenderFns } from "./scanAndSuspiciousItemBarChart.vue?vue&type=template&id=3abe6f80&scoped=true&"
import script from "./scanAndSuspiciousItemBarChart.vue?vue&type=script&lang=js&"
export * from "./scanAndSuspiciousItemBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe6f80",
  null
  
)

export default component.exports